import React from 'react'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core'
import CountrySelectField from '../common/countrySelectField'
import CompanySearchField from '../common/companySearchField'
import { WatchField } from '../../form'
import classNames from 'classnames'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import store from '../../store'
import { customerValidate } from '../../containers/validate'
import { useForm, Form, Field } from '../../form'
import IconTooltip from '../../utils/IconTooltip'
import { useSelector, useDispatch } from 'react-redux'
import { setCustomerFormReadOnly } from '../../actions'
import mobileView from '../../utils/mobile.utils'

const styles = (theme) => ({
  select: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    marginTop: theme.spacing(5),
    fontSize: '15px',
    fontWeight: 500,
    color: '#808080'
  },
  radioButton: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  mobileButton: {
    paddingLeft: mobileView ? '5px' : undefined,
    paddingRight: mobileView ? '5px' : undefined
  }
})

const defaultValues = {
  country: '1',
  company_name: '',
  business_id: '',
  customer_type: 'company',
  person_to_contact: '',
  person_to_contact_email: '',
  person_to_quick_pay_email: '',
  delivery_method: 'Sähköposti',
  delivery_address: '',
  zip_code: '',
  city: '',
  web_invoice: '',
  finvoice_operator: '',
  invoice_price_selection: false
}

const CustomerForm = ({
  classes,
  isEdit,
  saveCustomerUpdate,
  addNewCustomer,
  countryList,
  eInvoiceOperators,
  cancelCustomerUpdate,
  userType,
  closeCustomerFormDialog
}) => {
  const dispatch = useDispatch()
  const isReadOnly = useSelector((state) => state.customer.isReadOnly)

  React.useEffect(() => {
    if (!isEdit) {
      dispatch(setCustomerFormReadOnly(false))
    }
  }, [isEdit])

  const form = useForm({
    name: 'customer',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: customerValidate,
    keepEmptyValuesOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    if (isEdit) saveCustomerUpdate(values)
    else addNewCustomer(values)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <div className="row" id="customer-scroll-section">
              <div className="dashboard-content-header">
                {isReadOnly ? (
                  <h1>{t('asiakkaat.kats')}</h1>
                ) : isEdit ? (
                  <h1>{t('asiakkaat.muok')}</h1>
                ) : (
                  <h1>{t('asiakkaat.muok2')}</h1>
                )}
              </div>
            </div>
            <Form {...form}>
              <div className="row">
                <div className="dashboard-content-header">
                  <div style={{ textAlign: 'center', padding: '0px' }}>
                    <Field
                      name="customer_type"
                      inputType="radiogroup"
                      className={classes.radioButton}
                      horizontal
                      options={[
                        {
                          label: t('asiakkaat.company'),
                          value: 'company'
                        },
                        {
                          label: t('asiakkaat.private'),
                          value: 'private_person'
                        }
                      ]}
                      control={control}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-lg-6">
                    <CustomerInfo
                      classes={classes}
                      // searchCompanyDetails={searchCompanyDetails}
                      // companyLists={companyLists}
                      // loadSelectedCompany={loadSelectedCompany}
                      // apiSuccess={apiSuccess}
                      // closeCompanyLists={closeCompanyLists}
                      countryList={countryList}
                      // companySelected={companySelected}
                      control={control}
                      isReadOnly={isReadOnly}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-lg-6">
                    {invoiceInfo(
                      eInvoiceOperators,
                      classes,
                      control,
                      isReadOnly
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {isReadOnly ? (
                    <div
                      className="pull-right"
                      style={{
                        padding: '0px 0px 25px 0px',
                        marginRight: '15px'
                      }}
                    >
                      <Button
                        variant="outlined"
                        className={classes.button}
                        onClick={closeCustomerFormDialog}
                      >
                        {t('asiakkaat.close')}
                      </Button>
                    </div>
                  ) : isEdit ? (
                    <ul
                      className="nav nav-pills pull-right"
                      style={{ padding: '0px 25px 25px 0px' }}
                    >
                      <li>
                        <Button
                          variant="outlined"
                          className={
                            (classes.button,
                            classes.button1,
                            classes.mobileButton)
                          }
                          onClick={() => {
                            cancelCustomerUpdate()
                            form.reset()
                          }}
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                        >
                          {t('asiakkaat.perut')}
                        </Button>
                      </li>
                      <li>
                        <Button
                          variant="contained"
                          className={(classes.button, classes.mobileButton)}
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                          type="submit"
                        >
                          {t('asiakkaat.talen')}
                        </Button>
                      </li>
                    </ul>
                  ) : (
                    <div
                      className="pull-right"
                      style={{ padding: '0px 25px 25px 0px' }}
                    >
                      <Button
                        variant="outlined"
                        className={(classes.button, classes.mobileButton)}
                        disabled={
                          userType == 2 &&
                          store.getState().adminUser.selectedUser.email ==
                            undefined
                            ? true
                            : false
                        }
                        onClick={closeCustomerFormDialog}
                      >
                        {t('asiakkaat.back')}
                      </Button>
                      <Button
                        variant="contained"
                        className={(classes.button, classes.mobileButton)}
                        disabled={
                          userType == 2 &&
                          store.getState().adminUser.selectedUser.email ==
                            undefined
                            ? true
                            : false
                        }
                        type="submit"
                      >
                        {t('asiakkaat.lisaa')}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Form>
          </>
        )
      }}
    </Translation>
  )
}

const CustomerInfo = (props) => {
  const { classes, countryList, control, isReadOnly } = props

  return (
    <Translation>
      {(t) => {
        return (
          <div className="panel panel-default">
            {/* <div className="panel-heading">
              <h3 className="panel-title">{t('asiakkaat.h3a')}</h3>
            </div> */}
            <div
              className="panel-body"
              style={{ marginBottom: 25, paddingBottom: 30 }}
            >
              <div>
                <CountrySelectField
                  classes={classes}
                  countryList={countryList}
                  control={control}
                  disabled={isReadOnly}
                />
              </div>
              <CompanySearchField
                form="customer"
                name="company_name"
                control={control}
                disabled={isReadOnly}
              />
              <div>
                {/* KAS-339 Using watchfield to watch, if customer_type is company, business_id is required */}
                <WatchField control={control} fields="customer_type">
                  {(watch) => (
                    <Field
                      name="business_id"
                      inputType="textfield"
                      label={
                        watch.customer_type === 'company'
                          ? t('asiakkaat.label3') + '*'
                          : t('asiakkaat.label3')
                      }
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                      disabled={isReadOnly}
                    />
                  )}
                </WatchField>
              </div>
              <div>
                <Field
                  name="person_to_contact"
                  inputType="textfield"
                  label={t('asiakkaat.label4')}
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  disabled={isReadOnly}
                />
              </div>
              <div>
                <WatchField control={control} fields="delivery_method">
                  {(watch) => (
                    <Field
                      name="person_to_contact_email"
                      inputType="textfield"
                      label={
                        watch.delivery_method === 'Verkkolasku'
                          ? t('asiakkaat.label5b')
                          : t('asiakkaat.label5')
                      }
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                      disabled={isReadOnly}
                    />
                  )}
                </WatchField>
              </div>
              <div>
                <Field
                  name="person_to_quick_pay_email"
                  inputType="textfield"
                  label={t('asiakkaat.label7')}
                  labelStyle={mobileView ? { marginTop: '18px' } : {}}
                  className={classNames(
                    classes.textField,
                    classes.resize,
                    classes.label
                  )}
                  control={control}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const invoiceInfo = (eInvoiceOperators, classes, control, isReadOnly) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel panel-default">
          {/* <div className="panel-heading">
            <h3 className="panel-title">{t('asiakkaat.laskun')}</h3>
          </div> */}
          <div
            className="panel-body"
            style={{ marginBottom: 25, paddingBottom: 32 }}
          >
            <div style={{ whiteSpace: mobileView ? 'nowrap' : null }}>
              <Field
                name="delivery_method"
                inputType="select"
                label={t('asiakkaat.laskun')}
                className={classes.select}
                control={control}
                disabled={isReadOnly}
              >
                <MenuItem value="Sähköposti">{t('Sähköposti')}</MenuItem>
                <MenuItem value="Kirjeposti">{t('Kirjeposti')}</MenuItem>
                <MenuItem value="Verkkolasku">{t('Verkkolasku')}</MenuItem>
              </Field>
            </div>
            <div>
              <Field
                name="delivery_address"
                inputType="textfield"
                label={t('asiakkaat.label6')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
                disabled={isReadOnly}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '48%' }}>
                <Field
                  name="zip_code"
                  inputType="textfield"
                  label={t('asiakkaat.posti')}
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  disabled={isReadOnly}
                />
              </div>
              <div style={{ width: '48%' }}>
                <Field
                  name="city"
                  inputType="textfield"
                  label={t('asiakkaat.posti2')}
                  className={classNames(classes.textField, classes.resize)}
                  control={control}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div>
              <Field
                name="web_invoice"
                inputType="textfield"
                label={t('asiakkaat.verkko')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
                disabled={isReadOnly}
              />
            </div>
            <div style={{ whiteSpace: mobileView ? 'nowrap' : null }}>
              <Field
                name="finvoice_operator"
                inputType="select"
                label={t('asiakkaat.verkko2')}
                className={classes.select}
                control={control}
                disabled={isReadOnly}
              >
                {eInvoiceOperators}
              </Field>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                opacity: isReadOnly ? 0.5 : 1
              }}
            >
              <Field
                name="invoice_price_selection"
                label={t('invoice.priceSelection')}
                inputType="checkbox"
                className={classes.checkbox}
                control={control}
                disabled={isReadOnly}
                formControlStyle={{ width: 'auto' }}
              />
              <IconTooltip tooltipShow={t('asiakkaat.tooltip1')} />
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)
export default withStyles(styles)(CustomerForm)
